var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col items-center sm:justify-center sm:pt-0",class:{ 'min-h-screen': _vm.standalone }},[_c('div',{staticClass:"px-5 sm:w-1/5"},[_vm._t("logo")],2),_vm._v(" "),_c('div',{staticClass:"flex flex-col pb-6 pt-4 px-6 w-full overflow-hidden space-y-4 sm:max-w-lg sm:rounded-lg"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }